export const ROUTE_PATH = '/resetpassword';
